// Headline retention stat (backlog #15) — placed above BragChart per the
// attribution-pack design: the causality number, not another state number.
interface Props {
  rate: number | null;
  cohortSize: number;
}

export default function RetentionHero({ rate, cohortSize }: Props) {
  return (
    <div className="bg-white rounded-[10px] p-[18px] text-center">
      <div className="font-grotesk font-bold text-[40px] text-primary leading-none">
        {rate === null ? '—' : `${Math.round(rate * 100)}%`}
      </div>
      <div className="font-grotesk font-medium text-[11px] text-body-grey uppercase tracking-wide mt-2.5">
        Of first-timers come back within 2 weeks
      </div>
      <div className="font-grotesk text-[12px] text-[#a8a29e] mt-1.5">
        {rate === null
          ? cohortSize > 0
            ? `Need ${5 - cohortSize} more first-time ${5 - cohortSize === 1 ? 'customer' : 'customers'} to show this`
            : 'Unlocks after your first few repeat customers'
          : `Based on ${cohortSize} first-time ${cohortSize === 1 ? 'customer' : 'customers'}`}
      </div>
    </div>
  );
}
